<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>

  <data-table (detail)="goToParentOrganisation($event)" *ngIf="parentOrganisation"
                  [columns]="[{prop: 'title'}]"
                  [dataProviderParams]="{}"
                  [plainData]="[parentOrganisation]"
                  [hideSearch]=true
                  title='ParentOrganisation'>

  </data-table>
  <div *ngIf="parentOrganisation" class="spacer"></div>

  <data-table (detail)="goToOrganisationCustomer($event)" *ngIf="organisationCustomer"
                  [columns]="[{prop: 'organisationName'}]"
                  [dataProviderParams]="{}"
                  [plainData]="[organisationCustomer]"
                  [hideSearch]=true
                  title='OrganisationCustomer'>
  </data-table>
  <div *ngIf="organisationCustomer" class="spacer"></div>

  <data-table (detail)="goToGroup($event)" *ngIf="groups && groups.length"
                  [columns]="columns"
                  [dataProviderParams]="{}"
                  [plainData]="groups"
                  [hideSearch]=true
                  title='Assigned with Groups'>
  </data-table>

  <div class="spacer"></div>

  <data-table (detail)="goToRole($event)" *ngIf="roles && roles.length"
                  [columns]="columns"
                  [dataProviderParams]="{}"
                  [plainData]="roles"
                  [hideSearch]=true
                  title='Assigned with Roles'>
  </data-table>

</page-content>
